import {Injectable} from '@angular/core';
import {GraphVariableModel} from "../models/graph-variable.model";
import {Observable, Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {CookieService} from "ngx-cookie-service";

@Injectable({
  providedIn: 'root'
})
export class GraphService {
  private url = `${environment.apiGraphURL}/graph`;
  graphTypeSubject = new Subject<string>();
  graphVariablesSubject = new Subject<GraphVariableModel[]>;
  graphDataTransformersSubject = new Subject<string>();
  graphDataTransformerInterpolateSubject = new Subject<boolean>();
  graphDataTransformerMultiAnnualMeanSubject = new Subject<boolean>();
  resetGraph = new Subject<boolean>();

  private static graphPageSelectedVariablesCookieName = 'iolrSelectedVariables';
  private static datasetPageSelectedVariablesCookieName = 'iolrDatasetPageSelectedVariables';

  private static graphPageGraphTypeCookieName = 'iolrGraphType';
  private static datasetPagGraphTypeCookieName = 'iolrDatasetPageGraphType';

  private static graphPageDataTransformGraphCookieName = 'iolrDataTransformGraph';
  private static datasetPagDataTransformGraphCookieName = 'iolrDatasetPageDataTransformGraph';

  private static graphPageDataTransformInterpolateCookieName = 'iolrDataTransformInterpolate';
  private static datasetPagDataTransformInterpolateCookieName = 'iolrDatasetPageDataTransformInterpolate';

  private static graphPageDataTransformMultiAnnualMeanCookieName = 'iolrDataTransformMultiAnnualMean';
  private static datasetPagDataTransformMultiAnnualMeanCookieName = 'iolrDatasetPageDataTransformMultiAnnualMean';

  constructor(
    private http: HttpClient
  ) {
  }

  getLocalStorageSelectedVariables(key: string): any {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : [];
  }

  setLocalStorageSelectedVariables(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  deleteLocalStorageSelectedVariables(key: string): void {
    localStorage.removeItem(key);
  }

  getGraphData(variables: any, format: any): Observable<any> {
    let options = {};
    if (format !== 'json') {
      options = {responseType: 'text'}
    }
    return this.http.post(`${this.url}`, JSON.stringify(variables), options);
  }

  getSelectedVariablesKey(componentContext: 'graph-page' | 'dataset-page'): string {
    return componentContext === 'graph-page' ? GraphService.graphPageSelectedVariablesCookieName : GraphService.datasetPageSelectedVariablesCookieName;
  }

  getGraphTypeKey(componentContext: 'graph-page' | 'dataset-page'): string {
    return componentContext === 'graph-page' ? GraphService.graphPageGraphTypeCookieName : GraphService.datasetPagGraphTypeCookieName;
  }

  getDataTransformGraphKey(componentContext: 'graph-page' | 'dataset-page'): string {
    return componentContext === 'graph-page' ? GraphService.graphPageDataTransformGraphCookieName : GraphService.datasetPagDataTransformGraphCookieName;
  }

  getDataTransformInterpolateKey(componentContext: 'graph-page' | 'dataset-page'): string {
    return componentContext === 'graph-page' ? GraphService.graphPageDataTransformInterpolateCookieName : GraphService.datasetPagDataTransformInterpolateCookieName;
  }

  getDataTransformMultiAnnualMeanKey(componentContext: 'graph-page' | 'dataset-page'): string {
    return componentContext === 'graph-page' ? GraphService.graphPageDataTransformMultiAnnualMeanCookieName : GraphService.datasetPagDataTransformMultiAnnualMeanCookieName;
  }
}
